import { gql } from '@urql/core';

const APP_LEAD_FRAGMENT = gql`
  fragment AppLeadFields on AppLead {
    id
    email
    name
    phone
    companyName
    description
    utmContent
    utmCampaign
    utmSource
    utmTerm
    gclid
    fbclid
    integrations
    monthlyCustomers
    locationsCount
    reviewPlatforms
    reviewManagers
    interestedSolutions
    quizResultsJson
    quizResultsText
    googlePlaceId
    crmId
    address {
      address1
      city
      country
      state
      zip
    }
    orders {
      text
      json
      createdAt
    }
  }
`;

export const GET_LEAD_QUIZ_RESULTS = gql`
  query getLeadQuizResults($id: String!) {
    getLeadQuizResults(id: $id)
  }
`;

export const UPSERT_APP_LEAD = gql`
  ${APP_LEAD_FRAGMENT}

  mutation upsertAppLead($input: UpsertAppLeadInput) {
    upsertAppLead(input: $input) {
      ...AppLeadFields
    }
  }
`;
